import AddToCartIcon from "./AddToCartIcon";
import { CartConfigType } from "../types/types";

export const SymbolsExpalanation = ({ selectedDiagramId, cartConfig }: { selectedDiagramId: string | undefined; cartConfig: CartConfigType }) => {
  if (!cartConfig.inStockRow && !cartConfig.onRequestRow) {
    return null;
  }

  return (
    <div className="ps-5">
      {selectedDiagramId && (
        <div>
          {cartConfig.inStockRow && (
            <div className="flex">
              <AddToCartIcon tint={cartConfig.inStockRow?.color} />
              <strong className="ms-1 text-black lg:text-md text-xs">{cartConfig.inStockRow?.label}</strong>
            </div>
          )}

          {cartConfig.onRequestRow && (
            <div className="flex mt-2">
              <AddToCartIcon tint={cartConfig.onRequestRow?.color} />
              <strong className="ms-1 text-black lg:text-md text-xs">{cartConfig.onRequestRow?.label}</strong>
            </div>
          )}
        </div>
      )}
    </div>
  );
};
